import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { GuiasComponent, validar as validarGuias } from "./guias";
import { DepositosComp, validar as validarDepositos } from "./depositos";
import { CuentasPagoNotaDeCreditoComponent, validar as validarNotasCredito } from "./notasdecredito";
import { CuentasRepsComponent, validar as validarReps } from "./reps";
import { CuentasEntregaIngresosComponent, validar as validarEntregaIngresos } from "./entregingresos";


type Entity = models.ConfigContabilidad;

export interface Props {
    value: Entity;
    label: string;
    error?: kea.FieldError;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

/**
* Valida un Entity
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        DepositosBanco: validation.subrule(validarDepositos),
        Guias: validation.subrule(validarGuias),
        NotasDeCredito: validation.subrule(validarNotasCredito),
        Reps: validation.subrule(validarReps),
        EntregaIngresos: validation.subrule(validarEntregaIngresos),
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un cuenta guias
*/
export class CuentasComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Depositos = getField(DepositosComp);
        const Guias = getField(GuiasComponent);
        const NotasDeCredito = getField(CuentasPagoNotaDeCreditoComponent);
        const Reps = getField(CuentasRepsComponent);
        const EntregaIngresos = getField(CuentasEntregaIngresosComponent);


        return (
            <div>
                <kea.Panel title={this.props.label} error={this.props.error}>
                    <Guias field="Guias" label="Guías" />
                    <Depositos field="DepositosBanco" label="Depósitos" />
                    <NotasDeCredito field="NotasDeCredito" label="Notas de Crédito" />
                    <Reps field="Reps" label="REPs" />
                    <EntregaIngresos field="EntregaIngresos" label="Entrega de ingresos ZE" />
                </kea.Panel>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/configuraciones/edit/components/contabilidad/index.tsx